import React, { lazy, Suspense } from 'react';
import DeviationPageLoader from './_partials/DeviationPageLoader';
import ErrorBoundary from '../ErrorBoundary';
var DeviationPage = lazy(function () {
    return import(
    /* webpackChunkName: "devpage", webpackPrefetch: true, webpackPreload: true */
    './index');
});
export var LoadableDeviationPage = function (_a) {
    var isWholePageLoading = _a.isWholePageLoading, deviation = _a.deviation;
    if (isWholePageLoading) {
        return React.createElement(DeviationPageLoader, null);
    }
    return (React.createElement(ErrorBoundary, null,
        React.createElement(Suspense, { fallback: React.createElement(DeviationPageLoader, null) },
            React.createElement(DeviationPage, { deviation: deviation }))));
};
LoadableDeviationPage.displayName = 'LoadableDeviationPage';
export default LoadableDeviationPage;
//# sourceMappingURL=LoadableDeviationPage.js.map